export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12897.8c72f3a1.jpg";